import React, { useState, useEffect } from "react";
import { fireDB } from "../config";

import { collection, getDocs } from "firebase/firestore";

import { Box, Container, Grid } from "@mui/material";
import CategoryList from "../components/CategoryList";
export default function Category() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getCategories().then((res) => {
      setCategories(res);
    });
  }, []);

  async function getCategories() {
    var dataforTheCategories = [];
    const productForMenu = collection(fireDB, "categories");
    const docOfMenuCategories = await getDocs(productForMenu);
    docOfMenuCategories.forEach((doc) => {
      var tempData = doc.data();
      dataforTheCategories.push({
        cat_id: doc.id,
        title: tempData.title,
        cat_img: tempData.category_img,
        cat_position: tempData.position,
      });
    });
    return dataforTheCategories;
  }

  return (
    <Container sx={{ my: 2 }}>
      {categories.length !== 0 ? (
        <Grid container spacing={2}>
          {categories?.map((item, index) => (
            <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
              <CategoryList
                name={item?.title}
                image={item?.cat_img}
                id={item?.cat_id}
                position={item?.cat_position}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box>Loading...</Box>
      )}
    </Container>
  );
}
